export default {"src":"/_next/static/media/badge.c27eb247.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};